/**
 * User: daletan
 * Date: 7/29/14
 * Time: 5:24 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var $ = require('dibs-jquery-shim');
var DC = require('bunsen/helpers/dibsConstants');
var visitTracking = require('dibs-visit-tracking');

$(function() {
    var visitorTracking = new visitTracking.VisitorTracking();
    $.subscribe(DC.pageEventPrefix + ':updated', function() {
        var visitCountModel = visitorTracking.model;
        visitCountModel.incrementTracking();
        visitCountModel.save();
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/nonCritical.js
// module id = 4169
// module chunks = 62